<ng-container>
  <ng-container *ngIf="!(redirectToIssuerLoading$ | async); else loading">
    <bca-tab-stepper
      [highestRoute]="highestRoute$ | async"
      [currentRoute]="currentRoute$ | async"
      (tabClicked)="onTabClicked($event)"
    >
      <ng-container *ngFor="let page of pageData">
        <bca-tab
          [done]="(currentRoute$ | async) > page.route"
          [active]="(currentRoute$ | async) === page.route"
          [route]="page.route"
          [title]="page.title | translate"
        >
        </bca-tab>
      </ng-container>
    </bca-tab-stepper>

    <div class="nes-grid sm:nes-grid-cols-1 lg:nes-grid-cols-3 nes-my-5">
      <div class="sm:nes-col-span-1 lg:nes-col-span-2 tile">
        <ng-container [ngSwitch]="currentRoute$ | async">
          <bca-products-overview
            *ngSwitchCase="Route.COMPOSE"
          ></bca-products-overview>
          <bca-user-data *ngSwitchCase="Route.USER_DATA"></bca-user-data>
          <bca-company-data
            *ngSwitchCase="Route.COMPANY_DATA"
          ></bca-company-data>
          <bca-verify *ngSwitchCase="Route.VERIFY"></bca-verify>
          <bca-agreement *ngSwitchCase="Route.AGREEMENT"></bca-agreement>
        </ng-container>
      </div>

      <div class="nes-col-span-1">
        <ng-container *ngIf="(currentRoute$ | async) < Route.VERIFY">
          <div
            [stickyReceipt]="stickyReceipt$ | async"
            class="nes-hidden lg:nes-flex nes-flex-col"
          >
            <bca-receipt> </bca-receipt>

            <div class="nes-my-5 nes-mx-5">
              <nes-highlight-box type="info">
                <ns-product-info (action)="onActionClicked($event)">
                </ns-product-info>
              </nes-highlight-box>
            </div>

            <div class="nes-my-5 nes-mx-5 nes-border nes-rounded nes-p-4">
              <bca-usp-block></bca-usp-block>
            </div>

            <div class="nes-my-5 nes-mx-5 nes-border nes-rounded nes-p-4">
              <h3 class="headingXS nes-mb-3 nes-font-bold">
                {{ "RECEIPT.KEUZEHULP_PANEL.TEXT" | translate }} <br />
              </h3>
              <nes-button
                class="nes-w-full"
                variant="secondary"
                compact
                (click)="directToKeuzehulp()"
              >
                {{ "RECEIPT.KEUZEHULP_PANEL.BUTTON" | translate }}
              </nes-button>
            </div>
          </div>

          <bca-receipt-footer
            class="nes-fixed nes-bottom-0 nes-right-0 nes-left-0 lg:nes-hidden nes-z-raised"
            (open)="onReceiptOpened()"
            [totalProductCount]="totalProductCount$ | async"
            [totalReceiptPrice]="totalReceiptPrice$ | async"
          >
          </bca-receipt-footer>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div
      style="
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 4rem;
      "
    >
      <h3
        style="display: flex; justify-content: center"
        class="headingS loader-tekst"
      >
        {{ "AGREEMENT.ISSUER_LOADING" | translate }}
      </h3>
      <div class="basicLoader"></div>
    </div>
  </ng-template>
  <nes-sticky-footer id="sticky-footer-component">
    <div
      class="nes-flex nes-gap-4 nes-items-center nes-justify-between nes-h-[42px]"
    >
      <nes-price price="33" leading-text="prijs" stacked size="xl"></nes-price>
      <nes-button variant="brand"> Koop kaartje </nes-button>
    </div>
  </nes-sticky-footer>
</ng-container>
